export default {"src":"/_next/static/media/seamless-data-extraction.34cb9756.svg","height":75,"width":90,"blurWidth":0,"blurHeight":0};